import { plugin } from 'light-component';
import { t } from '@common';
import styles from './style.module.less';
import type { ReactElement } from 'react';

export function WidgetBlank(): ReactElement {
  return (
    <div className={styles.blankBody}>
      {t('暂无数据')}
    </div>
  );
}

plugin.register({ kind: 'widget', type: 'blank', component: WidgetBlank });
